// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__35t3C","checkboxCol":"Table_checkboxCol__2cdBE","emailCol":"Table_emailCol__ZM8fB","actionCol":"Table_actionCol__10Vee"};